var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLock = function SvgIconLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.153 10.264H6.847c-.813 0-1.472.659-1.472 1.472v5.153c0 .813.66 1.472 1.472 1.472h10.306c.813 0 1.472-.659 1.472-1.472v-5.153c0-.813-.66-1.472-1.472-1.472M8.32 10.264V7.319a3.68 3.68 0 1 1 7.361 0v2.945"
  })));
};
export default SvgIconLock;